import { render, staticRenderFns } from "./CncIconButton.vue?vue&type=template&id=237a04a2"
import script from "./CncIconButton.vue?vue&type=script&lang=js"
export * from "./CncIconButton.vue?vue&type=script&lang=js"
import style0 from "./CncIconButton.vue?vue&type=style&index=0&id=237a04a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports